<script>
export default {
  name: "AccountTabs",
  data() {
    return {
      tabs: [
        { to: "/account", label: "Dados cadastrais" },
        { to: "/account/contacts", label: "Contatos" },
        { to: "/account/professional", label: "Dados profissionais" },
        { to: "/account/security", label: "Segurança e senha" },
      ],
    };
  },
};
</script>

<template>
  <div>
    <div class="page-title-box">
      <h3 class="mb-0">Minha Conta</h3>
    </div>
    <ul class="nav nav-tabs account-tabs mb-3 flex-nowrap">
      <li v-for="tab in tabs" :key="tab.to" class="nav-item">
        <router-link :to="tab.to" exact class="nav-link text-nowrap" exact-active-class="active">{{ tab.label }}</router-link>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.account-tabs {
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
